import { render, staticRenderFns } from "./Theme.vue?vue&type=template&id=57ff2d4c&scoped=true&"
import script from "./Theme.vue?vue&type=script&lang=js&"
export * from "./Theme.vue?vue&type=script&lang=js&"
import style0 from "./Theme.vue?vue&type=style&index=0&id=57ff2d4c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ff2d4c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\YrtDev\\wms\\wms-site\\main\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57ff2d4c')) {
      api.createRecord('57ff2d4c', component.options)
    } else {
      api.reload('57ff2d4c', component.options)
    }
    module.hot.accept("./Theme.vue?vue&type=template&id=57ff2d4c&scoped=true&", function () {
      api.rerender('57ff2d4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Layout/components/Theme.vue"
export default component.exports